import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ArrayStrategy, objectToSearchParams } from '../../../api/api.helper';
import { ApiGateway } from '../../../api/ApiGateway.service';
import {
  InsightsOnboardingResponse,
  InsightsScheduleRequest,
  InsightsScheduleResponse,
} from './insights-schedule.model';

@Injectable({
  providedIn: 'root',
})
export class InsightsService {
  private endpoint = 'insights/';

  public constructor(private gateway: ApiGateway) {}

  public getScheduleInsights(request: InsightsScheduleRequest): Observable<InsightsScheduleResponse> {
    return this.gateway.get(`${this.endpoint}schedule`, {
      params: objectToSearchParams(request, ArrayStrategy.COMMA_SEPARATED),
    });
  }
  public getOnboardingInsights(): Observable<InsightsOnboardingResponse> {
    return this.gateway.get(`onboarding/${this.endpoint}`);
  }
}
